export function StrikethroughIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.073 4.245c-2.44 0-4.145 1.665-4.145 3.409 0 .866.42 1.713 1.144 2.346H6.526a4.862 4.862 0 01-.598-2.346c0-3.127 2.902-5.41 6.145-5.41 2.685 0 5.082 1.534 5.877 3.822a1 1 0 11-1.89.656c-.47-1.355-2.01-2.477-3.987-2.477zm-.345 8.809c.043.006.087.008.132.008 2.44 0 4.145 1.666 4.145 3.41 0 1.743-1.705 3.408-4.145 3.408-1.164 0-2.196-.395-2.936-1.007-.502-.415-.862-.923-1.052-1.47a1 1 0 10-1.889.656c.322.926.91 1.73 1.666 2.355 1.112.92 2.599 1.466 4.21 1.466 3.244 0 6.146-2.282 6.146-5.409 0-1.354-.544-2.55-1.426-3.471H19a1 1 0 100-2H5a1 1 0 100 2h6.146c.192.026.386.044.582.054z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
